import { createFileRoute } from "@tanstack/react-router";

import { NotificationPreferences } from "@/features/settings";

/**
 * ``/settings/notifications`` — proactive layer nudge preferences.
 *
 * Wraps the v2 ``<NotificationPreferences>`` panel inside the shared modal
 * Settings shell. The panel itself uses the existing generic preferences
 * endpoint (``PATCH /users/{id}/preferences``) for persistence — no new BE
 * route is required.
 */
export const Route = createFileRoute("/_authed/_modal/settings/notifications")({
  component: NotificationPreferences,
});
